var map = {
	"./btn-bj.png": "b702",
	"./camera.png": "c1ab",
	"./coin-dimd-bj.png": "9783",
	"./coin-dimd.png": "a837",
	"./coin-gct-bj-1.jpg": "6a4e",
	"./coin-gct-bj-2.png": "9498",
	"./coin-gct-bj-3.png": "a034",
	"./coin-gct-bj.jpg": "dad6",
	"./coin-gct.png": "c942",
	"./coin-rwa-bj-1.png": "72a1",
	"./coin-rwa-bj.jpg": "7130",
	"./coin-rwa.png": "5ba3",
	"./coin-top100-bj.png": "e6f0",
	"./coin-top100.png": "1e2b",
	"./download-app.png": "133a",
	"./footer-download.png": "d301",
	"./footer/1.png": "b6e6",
	"./footer/2 (2).png": "94c4",
	"./footer/2.png": "fe35",
	"./footer/3.png": "b901",
	"./footer/4.png": "8909",
	"./home-bj.png": "db7f",
	"./home-img1.png": "415b",
	"./home-img2.png": "f2da",
	"./icon/android-icon-black.png": "b1f3",
	"./icon/android-icon.png": "0033",
	"./icon/arrow-down.png": "bf6b",
	"./icon/arrow-top.png": "18ac",
	"./icon/back-border.png": "ae7b",
	"./icon/close-icon.png": "1ab3",
	"./icon/coin-hk-icon.png": "e303",
	"./icon/coin-icon.png": "e442",
	"./icon/coin-r-icon.png": "96b6",
	"./icon/copy.png": "bd04",
	"./icon/eye1.png": "bec3",
	"./icon/eye2.png": "bc4b",
	"./icon/icon-question.png": "5d29",
	"./icon/icon-tab1-s.png": "d8b3",
	"./icon/icon-tab1.png": "edac",
	"./icon/icon-tab2-s.png": "7387",
	"./icon/icon-tab2.png": "947a",
	"./icon/icon-tab3-s.png": "a38a",
	"./icon/icon-tab3.png": "04da",
	"./icon/ios-icon-balck.png": "9391",
	"./icon/ios-icon.png": "b154",
	"./icon/more-icon.png": "5876",
	"./icon/more-s-icon.png": "a636",
	"./icon/r-icon.png": "d938",
	"./icon/star-blue.png": "7ece",
	"./icon/star.png": "9082",
	"./icon/success-icon.png": "aab1",
	"./icon/upload-img.png": "ee848",
	"./icon/user-s.png": "1c02",
	"./icon/user.png": "3f07",
	"./icon/wallet-hot.png": "58f8",
	"./icon/wallet-icon1-s.png": "1195",
	"./icon/wallet-icon1.png": "25b1",
	"./icon/wallet-icon2-s.png": "3503",
	"./icon/wallet-icon2.png": "17f6",
	"./icon/warning-icon.png": "adef",
	"./icon/zuanshi-icon.png": "6b35",
	"./login-bj.png": "18b6",
	"./logo-black.png": "a622",
	"./logo-white.png": "f135",
	"./mall-item.png": "1d0c",
	"./mall-jietu.png": "bf85",
	"./mall-list-nodata.png": "b790",
	"./member-bj.png": "dc54",
	"./nav/download-s.png": "ffdd",
	"./nav/download.png": "1bf1",
	"./nav/netword.png": "1f07",
	"./nav/network-s.png": "0a7d",
	"./nav/news-s.png": "b365",
	"./nav/news.png": "d435",
	"./nav/wallet-s.png": "13bb",
	"./nav/wallet.png": "7a96",
	"./news-bj.png": "7b96",
	"./news-item.png": "c612",
	"./news-nodata.png": "ddef",
	"./no-data-yh.png": "91bf",
	"./no-data.png": "9955",
	"./partner-program-bj.png": "b757",
	"./qr-code-black.png": "d11d",
	"./qr-code.png": "3c8d",
	"./qrcode-black.png": "b43d",
	"./question-bj.png": "5ca0",
	"./question-black.png": "479c",
	"./user/1.png": "9af9",
	"./user/2.png": "0dc9",
	"./user/3.png": "5ded",
	"./user/4.png": "43c7",
	"./user/5.png": "dfcf",
	"./user/6.png": "5dbc5",
	"./user/7.png": "fc0a",
	"./user/8.png": "e45d",
	"./user/9.png": "8d3c",
	"./user/left1-s.png": "4f56",
	"./user/left1.png": "c451",
	"./user/left2-s.png": "592a",
	"./user/left2.png": "a2fd",
	"./user/left3-s.png": "7ced",
	"./user/left3.png": "5147",
	"./user/left4-s.png": "1867",
	"./user/left4.png": "1011",
	"./user/left5-s.png": "7349",
	"./user/left5.png": "3b95",
	"./user1.png": "a56a",
	"./user2.png": "3087",
	"./wallet1-bj.png": "e6a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bec";